import React from 'react';
import './style.css';

export default class LanguageSelector extends React.Component {
	render() {
		
		return (
			<div className="lang-selector">
				{this.props.languages && this.props.languages.map((lang) => (
					<span className={this.props.activeLanguage && this.props.activeLanguage.code === lang.code ?
						"span-flag" : "span-flag disabled"} key={lang.code}
					      onClick={() => {
						      this.props.onLanguageChange && this.props.onLanguageChange(lang);
					      }}>
						<img src={"/assets/images/flags/" + lang.code + ".svg"} alt={lang.code}/>
					</span>
				))}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/03-components/LanguageSelector/index.js